function requireModule() {
    var envsContext = require.context('./app', true, /\.env.js$/);
    envsContext.keys().forEach(envsContext);

    var constantsContext = require.context('./app', true, /\.constant.js$/);
    constantsContext.keys().forEach(constantsContext);

    var modulesContext = require.context('./app', true, /.module.js$/);
    modulesContext.keys().forEach(modulesContext);

    var filtersContext = require.context('./app', true, /.filter.js$/);
    filtersContext.keys().forEach(filtersContext);

    var componentsContext = require.context('./app', true, /.component.js$/);
    componentsContext.keys().forEach(componentsContext);

    var directivesContext = require.context('./app', true, /.directive.js$/);
    directivesContext.keys().forEach(directivesContext);

    var statesContext = require.context('./app', true, /.states.js$/);
    statesContext.keys().forEach(statesContext);

    var servicesContext = require.context('./app', true, /.service.js$/);
    servicesContext.keys().forEach(servicesContext);

    var authContext = require.context('./app', true, /.auth.js$/);
    authContext.keys().forEach(authContext);
}

requireModule();



// WEBPACK FOOTER //
// ../index.js